module.exports = __webpack_public_path__ + "img/11.d9cd8d53.svg";